const cn = {
	"401": {
		"oops": "糟糕！",
		"noAuth": "你没有权限访问该页面",
		"goback": "上一页",
		"gohome": "首页"
	},
	"404": {
		"notFound": "页面找不到了"
	},
	"version": {
		"to_old": "返回旧版",
		"to_new": "返回新版",
		"default_node": "默认节点",
		"default_theme": "默认主题",
		// "node_err": "用户不存在，切换节点失败",
		"custom_theme": "定制主题"
	},
	"intro": {
		"sys_msg": "系统消息",
		"gaa_msg": "告警提醒",
		"new_guide": "新手指引",
		"slider_quite": "退出引导",
		"slider_pre": "上一步",
		"slider_next": "下一步",
		"slider_enter": "进入新版",
		"step_project_1": "新系统的管理设备",
		"step_project_2": "新增",
		"step_project_3": "项目管理",
		"step_project_4": "功能，设备分项目进行管理。用户可对项目进行",
		"step_project_5": "新建、编辑、删除",
		"step_mode_1": "选择你喜欢的设备列表样式",
		"step_mode_2": "设备列表可以通过",
		"step_mode_3": "列表或者卡片",
		"step_mode_4": "形式进行呈现，您根据您的情况选择呈现方式。",
		"step_device_1": "快速的找到关注的设备",
		"step_device_2": "新增",
		"step_device_3": "关注设备",
		"step_device_4": "功能，",
		"step_device_5": "鼠标悬停",
		"step_device_6": "在设备上时,你可点击关注，",
		"step_device_7": "关注后",
		"step_device_8": "设备可在该项目中作为",
		"step_device_9": "置顶",
		"step_device_10": "，方便您找到关心的设备。",
		"step_operate_1": "更清晰的设备信息布局",
		"step_operate_2": "选择您想要了解的设备后，能快速的浏览设备的能量流图、设备信息、数据图表、参数分析、数据明细、告警信息。"
	},
	"plantCode": {
		"codeApplication": "体验码申请",
		"haveDevice": "如果你已有设备,可注册后登录使用",
		"goRegister": "前往注册",
		"useDemo": "还没有邀请码？邀请码仅用于功能演示",
		"applyNow": "现在申请",
		"code_is_required": "体验码不能为空",
		"pleaseCode": "请输入邀请码",
		"pleaseName": "请输入您的姓名",
		"PleaseCompanyName": "请输入公司名称",
		"PleaseCompanyAddress": "请输入公司地址",
		"PleaseNumber": "请输入您的联系电话",
		"PleaseEmail": "请输入您的邮箱",
		"PleaseApplication": "请描述您申请的理由",
		"reasonNotEmpty": "申请的理由不能为空",
		"successfulApplication": "申请成功,请关注您的手机或邮箱信息，我们会尽快给你回复"
	},
	"retrieveUser": {
		"forgetUser": "忘记账号",
		"illustrate": "如果您忘记的您的账号，可通过输入您账号下任一设备的PN号获得账号信息提示，帮助您回想起账号！",
		"pn": "请输入账号下任一设备的PN",
		"comfig": "确定",
		"Return_to_login": "返回登录",
		"accountInfo": "账号信息",
		"user": "您的用户名是",
		"phone": "您的账号绑定的手机号码是",
		"email": "您的账号绑定的邮箱是",
		"pleasePn": "请输入设备PN",
		"pnError": "您输入的PN有误",
		"pnErrorMsg": "未找到数采器"
	},
	"login": {
		"login": "登录",
		"loginSuc": "登录成功",
		"no_account_yet": "还没有帐号？",
		"remember_pwd": "记住密码",
		"no_invitation": "还没有体验码？请联系我们",
		"linkman": "益邦阳光",
		"signup": "立即注册",
		"usr": "用户名",
		"pwd": "密码",
		"sample_station": "演示",
		"invitation": "体验码",
		"invitationLogin": "体验码登录",
		"forgotPwd": "忘记密码？",
		"forgotUser": "忘记账号",
		"usrformat": " 账号格式(2<=用户长度<=32)",
		"pwdformat": " 密码格式(6<=密码长度<=32)",
		"YHLogin": "用户登录",
		"YZcode": "请输入验证码",
		"code": "滑动下方滑块完成拼图",
		"Swipe_right": "向右滑动",
		"scan_login": "扫码登录",
		"open": "打开",
		"Scancode_login": "扫一扫登录",
		"scanning": "扫描",
		"success": "成功",
		"Pleaseconfirm_login": "请确认登录",
		"SmartESS": "光储宝",
		"pv123": "PV123 ESS",
		"X_Tech": "X-Tech",
		"app_download": "APP下载",
		"scan_download": "手机扫码下载APP",
		"YZcode_format": "验证码格式错误，请输入数字",
		"no_validitycode": "邀请码不在有效期内",
		"auto_login": "自动登录",

	},
	"signup": {
		"login": "立即登录",
		"code": "6位验证码",
		"pwd": "6-32个字符(数字、字母、下划线),区分大小写",
		"confirm_password": "请再次输入密码",
		"phone": "手机",
		"phone_form": "32个字符以内,请准确填写，以便找回密码",
		"pn": "14或18个字符(仅可使用数字、字母)",
		"usr": "2-32个字符(仅可使用中文、字母、数字下划线)账号名",
		"email": "邮箱",
		"email_form": "64个字符以内,请准确填写,以便找回密码",
		"existing_account": "已有账号？",
		"Register_account": "账号注册",
		"signup": "注册",
		"emailSignup": "邮箱注册",
		"phoneSignup": "手机注册",
		"registered": "注册",
		"success": "注册成功",
		"mobileformat": "手机号格式错误(6-32个)",
		"mobileformat1": "请输入正确的手机号码",
		"emailformat": "请输入正确的邮箱",
		"usrformat": "账号格式错误,2-32个(仅可使用中文、字母、数字下划线)",
		"pwdformat": "密码格式错误,6~32个(仅可使用数字、字母、下划线)",
		"pnformat": "PN号格式错误,14或18位(仅可使用数字、字母)",
		"qiang": "强",
		"zhong": "中",
		"di": "弱",
		"qiangdu": "密码强度:",
		"Byte_1": "已输入",
		"Byte_2": "个字符",
		"usr_pl": "用户名",
		"pwd_pl": "密码",
		"confirm_pl": "请再次输入密码",
		"confirm_Pwdpl": "确认密码",
		"email_pl": "邮箱地址",
		"mobile_pl": "手机号码",
		"code_pl": "验证码",
		"PN_pl": "PN号",
		"too_simple": "密码过于简单，请重新输入",
		"country_pl": "国家或地区",
	},
	"createPlant": {
		"imageLimit": "图片仅支持jpg,png格式,最大不能超过8M",
		"fileExceed": "文件过大",
		"uploadSuccess": "上传成功",
		"basic_settings": "基本设置",
		"Standard_setting": "标准设置",
		"System_settings": "系统设置",
		"Solar_settings": "太阳能设置",
		"Grid_settings": "电网设置",
		"Battery_settings": "电池设置",
		"Battery_settingsTT": "电池通用设置",
		"Battery_settings1": "电池组1",
		"Battery_settings2": "电池组2",
		"Work_settings2": "设置系统工作状态",
		"Machine_settings2": "设置机器待载使能",
		"Clear_settings2": "故障清楚",
		"Control_settings": "储能机设置",
		"Load_setting": "负载设置",
		"other_settings": "其他设置",
		"Basic_setting": "基础设置",
		"Advanced_setting": "高级设置",
		"select_all": "全选",
		"pv": "光伏",
		"gd": "电网",
		"bt": "电池",
		"bc": "负载",
		"sy": "系统",
		"eg": "发电机",
		"hl": "家庭负载",
	},
	"Upload": {
		"Upload": "上传"
	},
	"menu": {
		"home": "首页",
		"datalogger": "数采器管理",
		"account": "账号管理",
		"device": "设备管理",
		"overview": "总览",
		"alarm": "告警管理",
		"setting": "系统设置",
		"personal": "个人信息",
		"basic": "基本信息",
		"password": "密码修改",
		"alarmSetting": "告警设置",
		"email": "邮箱设置",
		"mobile": "手机设置",
		"recharge": "充值设置",
		"pay": "流量充值",
		"record": "充值记录",
		"rate": "费率设置",
		"customize": "自定义设置",
		"firmware": "默认升级固件",
		"adaptiveFirmware": "自适应固件",
		"firmwarenew": "固件管理",
		"intelligenceUpgrade": "智能升级",
		"intelligenceUpgradeTitle": "暂无升级包,请联系厂商",
		"intelligenceUpgradeTitle1": "请确认设备是否进行智能升级？",
		"intelligenceUpgradeTitle2": "未查询到匹配升级包",
		"Total_user": "用户总数:",
		"myDevice": "我的设备",
		"strategy": "本地升级策略",
		"cloudsUpgrade": "云端升级",
		"functionalApplication": "功能应用",
		"browseAccount": "子账户管理",
		"log": "数采器日志",
		"actionLog": "操作日志",
		"Manufacturer": "厂家管理",
		"datalogger_list": "数采器列表",
		"manufacturer_account": "厂家账号",
		"manufacturer_code": "厂家编码",
		"protocol_binding": "数采器协议绑定",
		"type_code": "数采器类型编码",
		"protocol_change": "数采器协议更改",
		"AIP_Interface": "API接口界面",
		"protocol_operation": "协议操作工具",
		"recharge_management": "充值管理",
		"device_management": "设备管理",
		"KEY_List": "KEY列表",
		"Protocol_instruction": "协议指令管理",
		"Raw_data": "原始数据解析",
		"Recharge_remedy": "充值补救",
		"device_function": "设备管理功能",
		"Password_maintenance": "控制项密码维护",
	},
	"header": {
		"plant_owner": "电站业主",
		"personal_infor": "个人信息",
		"change_password": "修改密码",
		"bind_mobile": "绑定手机",
		"bind_email": "绑定邮箱",
		"language": "语言设置",
		"log_out": "退出系统",
		"skin": "皮肤切换",
		"shopping_mall": "商城",
		"operating_manual": "操作手册",
		"pleaseSelect": "请选择",
		"pleaseSelect1": "请选择时间",
		"pnAndAlias": "数采器PN号 / 数采器名称",
		"pnAndSN": "PN / SN"
	},
	"role": {
		"plantOwnerNew": "普通用户",
		"plantOwner": "电站业主",
		"manufacturer": "厂家账号",
		"distributor": "经销商",
		"group": "集团账号",
		"viewer": "电站浏览者",
		"all": "所有"
	},
	"statistic": {
		"All": "所有",
		"regiontotal": "区域总数",
		"deviceStatus": "设备状态",
		"regionPercent": "区域占比",
		"userActivity": "用户活跃率",
		"dataUpdateTime": "数据更新时间",
		"normal": "正常",
		"offline": "离线",
		"Allstate": "所有状态",
		"warning": "警告",
		"fault": "故障",
		"standby": "待机",
		"totalDevice": "所有设备",
		"allDevice": "设备总数",
		"totalRegion": "所有区域",
		"other": "其它",
		"allAccount": "所有用户",
		"generalAccount": "业主用户",
		"adminAccount": "经销商用户",
		"active": "活跃",
		"inactive": "不活跃",
		"pv": "光伏板数据",
		"gd": "电网数据",
		"sy": "设备数据",
		"bt": "电池数据",
		"bc": "负载数据"
	},
	"account": {
		"title_pwd": "请输入正确的密码",
		"title_pwd1": "请输入6-32位密码",
		"title_pwd2": "请再次输入新密码",
		"title_mobile": "请输入11位手机号",
		"title_edit": "请输入需要编辑的信息",
		"title_info": "请输入正确邮箱",
		"title_info1": "请输入正确手机号码",
		"allAccount": "所有用户",
		"userAccount": "用户",
		"groupAccount": "分组",
		"uselists": "用户管理列表",
		"accountManage": "账号管理",
		"groupManage": "分组管理",
		"activeStatus": "活跃程度",
		"accountGroup": "用户分组",
		"createAccount": "创建账号",
		"relatedOwner": "关联业主",
		"relatedSuccess": "关联成功",
		"adminRelated": "请选择管理员",
		"role": "用户类型",
		"role1": "用户类型：",
		"selectUserType": "请选择用户类型",
		"generalAccount": "普通账号",
		"manageAccount": "管理员账号",
		"accountName": "用户名",
		"accountName1": "用户名：",
		"accountName2": "请输入用户名",
		"accountRole": "角色",
		"nickname": "用户昵称",
		"nickname1": "用户昵称：",
		"password": "用户密码",
		"password1": "用户密码：",
		"newPwd": "新密码",
		"newPwd1": "新密码：",
		"confirmpassword": "确认密码",
		"confirmpassword1": "确认密码：",
		"createTime": "创建时间",
		"accountStatus": "用户状态",
		"dataloggerNum": "数采器数量",
		"deviceNum": "设备数量",
		"projectNum": "项目数量",
		"lastLogin": "最后登录",
		"editUser": "编辑用户",
		"editAccount": "编辑账号",
		"group": "分组",
		"group1": "分组：",
		"groupto": "分组到",
		"changeGroup": "移动分组到：",
		"chooseGroup": "请选择分组",
		"changeGroupSuc": "移动分组成功",
		"defaultGroup": "默认分组",
		"enable": "启用",
		"disable": "禁用",
		"confirmDisable": "确定禁用该用户吗?",
		"afterDisable": "禁用后该账号将无法登录，无法查看或修改该账号的相关内容",
		"disableSuc": "禁用成功",
		"confirmEnable": "确定启用该用户吗?",
		"deleteUser": "删除账号",
		"afterEnable": "启用后该账号可恢复登录，查看或修改该账号的相关内容",
		"confirmDelete": "确定删除吗?",
		"notRecovered": "删除后将无法恢复...",
		"deleteSuc": "删除成功",
		"resetPwd": "重置密码",
		"allTypeUser": "所有类型用户",
		"powerStationOwner": "电站业主",
		"powerStationViewer": "电站浏览者",
		"admin": "管理员",
		"riyueyuan_lineSonAdmin": "产线子管理员",
		"riyueyuan_SonAdmin": "子管理员",
		"nodata": "暂无数据",
		"reason": "不显示图表原因可能是:",
		"reason1": "设备暂无数据",
		"reason2": "设备协议无发电量、用电量、买电量、卖电量、充电量、放电量的参数字段",
		"reason3": "设备协议无发电功率、负载功率、电池功率、电网功率的参数字段",
		"createSuc": "创建账号成功",
		"resetPwdSuc": "重置密码成功",
		"allGroup": "所有分组",
		"unclassified": "未分组",
		"cannotRedirect": "此账号不是储能帐号，不能跳转",
		"newPwdEmpty": "新密码不能为空，请进行填写！",
		"accountList": "账号列表",
		"mobile": "手机",
		"mobile1": "手机：",
		"email": "邮箱",
		"email1": "邮箱：",
		"modifiedsuccess": "用户信息修改成功!",
		"enablesuccess": "启用成功!",
		"disablesuccess": "禁用成功!",
		"groupsuccess": "分组操作成功!",
		"pwdresetsuccess": "密码重置成功!",
		"Deletesuccessfully": "删除账户成功!",
		"plantOwner": "电站业主",
		"distributor": "经销商",
		"operate": "操作",
		"Edit": "编辑",
		"Delete": "删除",
		"binding": "绑定",
		"ascription": "归属",
		"ascriptionSuccess": "归属成功",
		"ascription_result": "归属结果",
		"cancel": "取消",
		"finish": "完成",
		"confirm": "确定",
		"submit": "提交",
		"deletegroupsuccess": "移出分组成功!",
		"deletegroup": "移出分组",
		"currentTotal": "当前共",
		"projects": "项项目",
		"searchPro": "搜索项目",
		"devices": "台设备",
		"accounts": "个用户",
		"placeholder": "搜索用户名/手机号码",
		"placeholder1": "请输入用户名/手机号码",
		"lastLoginTs": "最后登录时间",
		"enterHome": "进入主页",
		"ownedDevices": "拥有设备",
		"Distribution_collector": "分配采集器",
		"tooltipContent": "管理员可以通过订单号，将订单下的所有数采器分配给某个下级经销商",
		"Distribution_method": "分配方式",
		"Batch_allocation": "批量分配",
		"Individual_allocation": "单个分配",
		"Order_allocation": "订单分配",
		"PNNum": "PN号",
		"order_number": "订单号",
		"Allocation_result": "分配结果",
		"Assigned_successfully": "分配成功",
		"order_check": "核对",
		"Confirm_assignment": "确认分配给",
		"IsIt": "吗",
		"limitFormat": "只能上传\"xlsx\"和\"xls\"格式的文件",
		"Ple_orderNum": "请输入订单号",
		"Ple_orderNum1": "请输入正确订单号",
		"Ple_orderNum2": "该订单下有",
		"Ple_orderNum3": "个采集器，确认分配给",
		"err_orderNum": "订单中有",
		"err_orderNum1": "个采集器已被绑定，请确认订单中的采集器未被绑定",
		"dataogger_swith": "是否可添加数采器",
		"dataogger_swithTip": "该账号是否可拥有添加数采器权限",
		"account_number": "账号",
		"Role_authority": "权限",
		"authority_Management": "权限管理",
		"Related_roles": "关联角色",
		"Ple_role1": "请选择关联角色",
		"Ple_role2": "请输入角色名称/ID",
		"Add_role": "新增角色",
		"Edit_role": "编辑角色",
		"Role_id": "角色ID",
		"Role_name": "角色名称",
		"Ple_role3": "请输入角色名称",
		"Role_des": "角色描述",
		"Ple_role4": "请输入角色描述",
		"module": "模块",
		"First_page": "页面",
		"Secondary_page": "二级页面",
		"Function_points": "功能点",
		"Remove_role": "删除角色",
		"Ple_role5": "请勾选账号权限",
		"No_permission_prompt": "无权限，请联系上级管理员",
		"Ple_role6": "角色名称已存在，请重新输入",
		"limit_UserTypeNum": "超出限制，已存在该账号类型",
		"limit_UserTypeDataPermission": "经销商账号不能绑定勾选了数据权限的角色",
		"edit_limit_UserTypeDataPermission": "角色已关联经销商账号，无法编辑数据权限",
		"dataPermission": "数据权限",
		"functionalPermission": "功能权限",
	},
	"group": {
		"Create_groups": "创建分组",
		"Edit_groups": "编辑分组",
		"Groups_list": "分组列表",
		"Group_name": "分组名称",
		"Group_name1": "分组名称：",
		"userCount": "分组用户数",
		"note": "分组备注",
		"note1": "分组备注：",
		"Operate": "操作",
		"Delete": "删除",
		"cancel": "取消",
		"finish": "完成",
		"confirm": "确认",
		"deletegroup": "删除分组",
		"deleteConfirm": "确定要删除此分组?",
		"entername": "请输入分组名称",
		"deletesuc": "删除分组成功",
		"creatsuc": "创建分组成功",
		"editsuc": "编辑分组成功"
	},
	"device": {
		"set": "设置",
		"ownerShip": "业主变更",
		"oldOwner": "原业主：",
		"nweOwner": "新业主：",
		"loading": "加载中...",
		"moreLoading": "滚动加载更多",
		"pleaseDate": "请选择日期",
		"noDate": "不能选择未来日期",
		"deviceDebug": "设备调试",
		"upgradeType": "升级方式：",
		"defaultUpgrade": "默认升级",
		"cloudUpgrade": "云端升级",
		"continueUpgrade": "继续升级",
		"continueUpgradeSuccess": "继续升级添加成功",
		"step": "开始步骤：",
		"firmware_step_message": "请输入开始步骤",
		"numberRlues": "请输入正确步骤数",
		"firmware_package_message": "请选择固件",
		"firmware_type_message": "请选择类型",
		"baudrate_message": "请选择波特率",
		"device_continueUpgrade": "设备继续升级",
		"read": "读取",
		"distribute": "下发",
		"optionTitle": "已选择",
		"optionTitle1": "项",
		"optionTitle2": "设备参数选择不能超过4个",
		"optionTitle4": "设备参数选择不能超过12个",
		"optionTitle3": "请不要选择超过2个不同单位的选项",
		"upBatchDeviceTip": "注意：批量升级是给多个设备升级同一个设备固件，如不清楚设备所适合的固件，请谨慎选择！",
		"upSuccessDevice": "升级成功的设备",
		"upFailDevice": "升级失败的设备",
		"brandDevice": "设备",
		"brand0": "其他储能机",
		"brand1": "离网逆变器",
		"brand2": "逆变器",
		"brand3": "储能一体机",
		"Allthemachines": "所有设备",
		"deviceList": "设备列表",
		"device": "设备",
		"datalogger": "数采器",
		"dataloggerList": "数采器列表",
		"followList": "关注设备",
		"proList": "项目列表",
		"pro": "项目",
		"deviceName": "设备名称",
		"dataview": "实时参数",
		"dataTips": "当前设备处于离线状态，无实时数据。",
		"overview": "统计概览",
		"chart": "数据图表",
		"analysis": "参数分析",
		"clause": "数据明细",
		"Current_data": "当前数据",
		"chosenParam": "已选参数",
		"optionalParam": "可选参数",
		"reset": "重置",
		"energyFlow": "能量流图",
		"device_name": "设备名称",
		"device_pn": "PN号",
		"device_sn": "设备SN",
		"device_status": "设备状态",
		"device_upgrade1": "最近一条升级记录",
		"device_upgradeFirmware": "选择一个固件包给设备升级",
		"device_upgradeTime": "升级时间",
		"device_upgradeName": "升级固件名称",
		"device_upgradeStatus": "升级状态",
		"device_upgradeProgress": "升级进度",
		"device_type": "设备类型",
		"device_code": "通讯协议",
		"device_code_form": "通讯协议：",
		"device_model": "设备型号",
		"User_belong": "所属用户",
		"field": "字段控制",
		"Datalogger_belong": "所属数采器",
		"detail": "查看详情",
		"pageSize": "当页显示",
		"follow": "关注",
		"unfollow": "取消关注",
		"report": "报表",
		"timeSlot": "时间段",
		"datalogger_pn": "数采器PN",
		"coll_alias": "数采器别名",
		// "device_address": "设备地址",
		"generation": "光伏板",
		"grid": "电网",
		"inverter": "逆变器",
		"battery": "电池",
		"consumption": "负载",
		"relay": "微逆",
		"alternator": "发电机",
		"familyLoad": "家庭负载",
		"solar": "光伏",
		"cur_today": "今日",
		"cur_thismonth": "本月",
		"cur_thisyear": "今年",
		"cur_day": "日",
		"cur_month": "月",
		"cur_year": "年",
		"day": "实时功率",
		"month": "当月电量",
		"year": "当年电量 ",
		"all": "总电量",
		"pvPower": "发电功率",
		"gridPower": "电网功率",
		"batteryPower": "电池功率",
		"loadPower": "负载功率",
		"generated": "发电量",
		"charged": "充电量",
		"discharged": "放电量",
		"sold": "卖电量",
		"bought": "买电量",
		"used": "用电量",
		"normal": "正常",
		"offline": "离线",
		"warning": "警告",
		"fault": "故障",
		"standby": "待机",
		"universal_firmware": "通用固件",
		"communication_firmware": "通讯版固件",
		"control_firmware1": "控制固件1",
		"control_firmware2": "控制固件2",
		"control_firmware_bms": "BMS固件",
		"control_firmware_slavmcu": "SlavMCU固件",
		"default": "默认",
		"modifySuc": "修改成功",
		"instruction_response": "正在发送指令，等待响应...",
		"debug_suc": "调试成功",
		"Debugfail": "调试失败，设备已离线",
		"Send_suc": "下发指令成功",
		"Send_Input": "请输入要下发的操作值",
		"Send_fail": "下发指令失败",
		"fileExceed": "文件过大",
		"uploadSuccess": "上传成功",
		"error1": "只能上传\".bin\"和\".hex\"格式的文件",
		"file_fist": "请先选择要升级的固件",
		"updatefail": "升级失败，采集器可能离线，或者检查是否与采集器通讯正常",
		"update_suc": "升级成功",
		"deleteSuc": "删除成功",
		"Operation": "操作",
		"edit": "编辑",
		"debug": "调试",
		"upgrade": "批量升级",
		"upgrade1": "升级",
		"more": "更多操作",
		"one_click_read": "一键读取",
		"cloudsUpgrade": "云端升级",
		"queryUpgrade": "批量查询升级进度",
		"control": "控制",
		"delete": "删除",
		"modify_alias": "编辑设备",
		"serial_number": "设备SN：",
		"device_alias": "设备名称：",
		"cancel": "取消",
		"confirm": "确定",
		"Device_sn": "设备序列号",
		"Device_pn": "设备PN：",
		"Instruction": "指令：",
		"such_as": "如：AA BB CC DD EE FF",
		"return_content": "返回内容：",
		"send": "发送指令",
		"clear_data": "清除数据",
		"clear_val": "清除",
		"copy_val": "复制",
		"copy_val_yes": "复制成功",
		"copy_val_no": "复制失败",
		"Field_Name": "字段名",
		"Unit": "单位",
		"current_val": "当前值",
		"Battery_voltage": "蓄电池电压",
		"Magnification": "倍率",
		"Send_Command": "指令下发",
		"device_upgrade": "设备固件升级",
		"device_cloudsUpgrade": "设备云端升级",
		"select_firmware": "固件：",
		"select_file": "请选择固件",
		"firmware_type": "固件类型：",
		"select_type": "请选择固件类型",
		"upgrade_brate": "波特率：",
		"select_brate": "请选择波特率",
		"Upload": "上传固件",
		"Upload1": "上传新固件",
		"confirm_deldte": "确认删除吗?",
		"deleteDevice": "删除设备",
		"Today_income": "当日发电收益",
		"Cumulative_income": "发电总收益",
		"sellProfit_Today": "当日卖电收入",
		"sellProfit_Total": "卖电总收入",
		"buyProfit_Today": "当日买电支出",
		"buyProfit_Total": "买电总支出",
		"noAuth": "无所属用户，无权限查看",
		"statistic": "统计",
		"protocolStatistic": "通讯协议统计",
		"chooseProtocol": "选择协议：",
		"parameter": "参数",
		"value": "值",
		"Upgrading": "正在升级中,请稍等",
		"System_Failed": "由于通信异常或其他原因导致系统未能启动设备升级流程",
		"Device_Offline": "设备或数采器已离线",
		"In_Upgrading": "设备或数采器已经在升级中",
		"Update_Completed": "升级完成",
		"Voltage": "电压",
		"Electric": "电流",
		"power": "功率",
		"frequency": "频率",
		"Input_form": "输入表",
		"add": "增加",
		"Output_table": "输出表",
		"Please_parameter": "请选择一个参数",
		"Successfully_modified": "修改成功",
		"edit_control": "编辑设备控制权限",
		"Equipment_agreement": "设备协议",
		"Check_all": "全部勾选",
		"Cancel_all": "全部取消",
		"administrator_cansee": "选中权限代表 :管理员可见，不选中代表不可见。",
		"person_cansee": "选中权限代表 : 业主可见，不选中代表不可见。",
		"admin_authority": "管理员权限",
		"person_authority": "业主权限",
		"noDataPlease": "无数据,请重新选择时间",
		"Sn_deviceName": "设备SN/设备名称/PN/用户名",
		"deviceInfo": "设备信息",
		"alarmInfo": "告警信息",
		"deviceNo": "您还没有添加设备",
		"showParam": "显示参数",
		"selecParameters": "已选择参数",
		"refresh": "刷新",
		"obtain": "获取",
		"moveResults": "移动结果",
		"moveSuc": "移动成功",
		"maxSelect": "最多只能勾选7个参数",
		"minSelect": "至少需要勾选1个参数",
		"loadMore": "加载更多 ...",
		"upDevice": "设备升级",
		"addUpgrade": "添加升级任务",
		"upgradeProgress": "当前升级进度",
		"deviceUpgradeProgress": "设备升级进度",
		"addUpgradeSuccess": "添加成功",
		"domain": "域名",
		"create_ctrl_title": "创建设备控制项维护",
		"edit_ctrl_title": "编辑设备控制项维护",
		"delete_domain": "删除域名",
		"delete_tips": "确定删除该定制域名设备控制项密码吗？",
		"hostname_required": "域名不能为空",
		"device_rerolling": "设备重滚",
		"device_synchronization": "设备同步",
		"update_first_data_time": "修改设备第一笔时间",
		"delete_device_chart_data": "删除设备图表数据",
		"delete_device_data": "删除设备数据明细",
		"SN_required": "请输入SN号",
		"device_code1": "设备编码",
		"devcode_required": "请输入设备编码",
		"device_address":"通讯地址",
		"devaddr_required": "请输入通讯地址",
		"devaddr_again": "请再次输入通讯地址",
		"PN": "数采器编码",
		"SN": "设备序列号",
		"SN_again": "请再次输入SN",
		"search_btn": "查询",
		"tips1": "提示：从mongodb往mysql同步，设备发电量不对，请重滚，后同步（不一定会使发电量正确，有可能是错误数据明细导致）",
		"tips2": "提示：请再次输入设备序列号和通讯地址",
		"tips3": "提示：数据明细一旦删除就再也找不回来，对应图表的数据永久无法再计算出来",
		"tips4_1": "提示：当前设备时区为",
		"tips4_2": "请注意设备时区，根据当前时区，添加相应时间，并再次输入设备序列号和通讯地址",
		"delete_tips_1": "确定删除时间戳:",
		"delete_tips_2": "这条数据吗",
		"sn_is_required": "SN不能为空",
		"sdate_required":"开始时间不能为空",
		"edate_required":"结束时间不能为空",
		"data_tips":"参数未填写完整",
		"match_tips":"两次设备序列号和通讯地址填写不一致",
		"unbind_tips":"该设备并未绑定业主，请先绑定业主"
	},
	"alarm": {
		"device_Warning": "设备告警",
		"device_Error": "设备错误",
		"device_Fault": "设备故障",
		"Alarm_Event": "告警事件",
		"Today_Alarm": "今日告警数",
		"Alarm_Type": "告警类型",
		"Device_Type": "设备类型",
		"Alarm_Status": "处理状态",
		"Alarm_List": "告警列表",
		"deletes": "删除",
		"tips": "提示",
		"details": "详情",
		"alarmDetails": "报警详情",
		"alarmInfo": "报警情况",
		"alarmDevice": "设备信息",
		"delete_alarm": "确定要删除此告警？",
		"Cancel": "取消",
		"Confirm": "确认",
		"Close": "关闭",
		"processed": "已处理",
		"untreated": "未处理",
		"allAlarm": "告警事件总数",
		"alarmStatus": "告警处理状态统计",
		"warningTitle": "近7日告警数",
		"faultTitle": "近7日故障数",
		"alarmNum": "告警数",
		"faultNum": "故障数",
		"all": "所有的",
		"warning": "告警",
		"error": "错误",
		"fault": "故障",
		"offline": "离线",
		"inverter": "逆变器",
		"monitor": "环境监测仪",
		"smart_meters": "智能电表",
		"combining_manifolds": "汇流箱",
		"Camera": "摄像头",
		"Battery": "电池",
		"Charger": "充电器",
		"storage": "储能机",
		"Prevent_arcing_island": "防孤岛装置",
		"Microinverter": "微型逆变器",
		"Occurrence_time": "发生时间",
		"endtime": "结束时间",
		"Device_Name": "设备名称",
		"Device_PN": "数采器PN号",
		"Plant": "所属电站",
		"Alarm_Code": "告警编码",
		"Alarm_Describe": "告警描述",
		"Device_SN": "设备SN",
		"device_alias": "设备别名",
		"device_address": "设备地址",
		"User": "所属用户",
		"Status": "状态",
		"Operation": "操作",
		"Delete_selected": "删除所选",
		"deleted_successfully": "告警删除成功!",
		"Alarm_Msg": "新消息",
		"Intro_Msg": "新手指引",
		"Alarm_Read": "你已阅完所有告警通知",
		"Alarm_data": "暂时没有最新消息了哦!",
		"Alarm_Message": "您的",
		"Alarm_Message1": "设备出现",
		"curSelected": "当前选中",
		"_Data": "条数据",
		"more": "更多",
		"ruleManage": "告警过滤规则管理",
		"ruleNew": "新增规则",
		"ruleName": "规则名称",
		"timeSlot": "时间段",
		"deviceType": "设备类型",
		"deviceFilter": "过滤设备",
		"alrmType": "过滤告警类型",
		"alrmDes": "过滤告警描述",
		"filterHistory": "过滤历史",
		"clearHistory": "清除历史",
		"view": "查看",
		"back": "返回",
		"exportArchive": "导出归档告警",
		"archiveRecord": "归档记录",
		"archiveTip": "列表包含所有未处理告警及7日内已处理记录"
	},
	"datalogger": {
		"activeStatus": "激活状态",
		"Active": "已激活",
		"notActive": "未激活",
		"timeZone": "时区",
		"please_title": "请输入'YES'，确认恢复出厂状态",
		"frequency": "采集频率",
		"heartbeat": "心跳",
		"warehousing_time": "入库时间",
		"start_address": "轮询起始地址",
		"deadline_address": "轮询截止地址",
		"title_usr": "该数采器无所属用户",
		"datalogger_log": "日志",
		"min_addr": "最小地址",
		"max_addr": "最大地址",
		"transmission": "纯透传标识",
		"transparent_set": "纯透传协议集合",
		"devcode": "设备厂家编码",
		// "protocol_code": "协议厂家编码",
		"domain_name": "上线域名",
		"transmission1": "本地采集模式",
		"transmission2": "纯透传模式",
		"noDate": "请选择3天以内的日期",
		"paramSetting": "参数设置",
		"paramName": "参数名称",
		"paramPar": "参数编号",
		"paramVal": "参数的值",
		"dataloggerView": "数采器详情",
		"describe": "描述",
		"field_name": "字段名",
		"checkVal": "数值",
		"resetTitle1": "确定重置数采器吗？（1: 使其可再注册, 2: 清除下属设备, 3: 删除采集器下的所有数据）",
		"unbingTitle": "确定解绑数采器吗？（1: 解除其绑定的经销商管理员；2：重新绑定，请登录相应的经销商管理员添加该数采器）",
		"getTitle": "参数获取",
		"postTitle": "参数设置",
		"debugeTitle": "设置调试",
		"getName": "参数获取(十进制)",
		"postName": "参数编号(十进制)",
		"debugeName": "命令：",
		"getVal": "当前值：",
		"postVal": "设置值：",
		"debugeVal": "结果：",
		"debugeAddr": "设备地址：",
		"getSucc": "获取成功",
		"postSucc": "设置成功",
		"debugeSucc": "下发成功",
		"copyVal": "复制值",
		"huoqu": "获取",
		"shezhi": "设置",
		"xiafa": "下发指令",
		// "timing": "令 时",
		// "winterTime": "冬令时",
		// "daylightTiming": "夏令时",
		"copy": "复制成功",
		"flowCard": "未查询到有效卡",
		"province": "省/州",
		"city": " 城 市",
		"county": "县/区",
		"country": "国 家",
		"Flowcard_status": "流量卡状态",
		"GPRS_traffic": "GPRS流量",
		"upBatchDataloggerTip": "注意：批量升级是给多个数采器升级同一个数采器固件，如不清楚数采器所适合的固件，请谨慎选择！",
		"upSuccessDatalogger": "升级成功的数采器",
		"upFailDatalogger": "升级失败的数采器",
		"Datalogger_Status": "数采器状态",
		"com_method": "通讯方式",
		"Datalogger_PN": "数采器PN号",
		"Datalogger_List": "数采器列表",
		"Datalogger_Name": "数采器名称",
		"Ple_PN": "请输入数采器PN号",
		"Ple_Alias": "请输入数采器名称",
		"Datalogger_type": "数采器类型",
		"Datalogger_model": "型号",
		"Datalogger_method": "通讯方式",
		"Status": "状态",
		"usr_belong": "所属用户",
		"administrator": "所属管理员",
		"Communication_balance": "通讯费余额",
		"load": "带载数",
		"Firmware_Version": "固件版本",
		"signal": "信号",
		"Operation": "操作",
		"edit": "编辑",
		"reboot": "重启",
		"unbind": "解绑",
		"more": "更多",
		"resetData": "重置数据",
		"unbindUsr": "解绑业主",
		"debug": "调试",
		"upgrade": "升级",
		"delete": "删除",
		"deleteTitle": "删除数采器",
		"reset": "重置",
		"resetCode": "请输入YES确认",
		"modify_datalog": "数采器信息修改",
		"cancel": "取消",
		"confirm": "确定",
		"datalogger_debug": "数采器调试",
		"communication_address": "通讯地址：",
		"Instruction": "指令：",
		"such_as": "如：AA BB CC DD EE FF",
		"return_content": "返回内容：",
		"send": "发送指令",
		"check": "校验",
		"InstructionType": "指令格式",
		"endMarker": "结束符",
		"noMarker": "无结束符",
		"noCheck": "无校验",
		"InstructionIssue": "下发指令",
		"Insufficient": "次数不足",
		"clear_data": "清除数据",
		"device_upgrade": "设备固件升级",
		"select_firmware": "固件：",
		"select_file": "请选择固件",
		"Upload": "上传固件",
		"prompt_message": "提示信息",
		"confirm_deldte": "数采器删除后，您将无权管理数采器相关的所有数据",
		"Normal": "正常",
		"Offline": "离线",
		"Online": "在线",
		"Normal1": "在线状态",
		"Offline1": "离线状态",
		"Allstate": "所有状态",
		"modifySuc": "修改成功",
		"resetSuc": "重置成功",
		"unbindSuc": "解绑成功",
		"devaddrfail": "通讯地址不能为空",
		"Debugfail": "调试失败，数采器已离线",
		"instruction_response": "正在发送指令，等待响应...",
		"fileExceed": "文件过大",
		"uploadSuccess": "上传成功",
		"error1": "只能上传\".bin\"和\".hex\"格式的文件",
		"file_fist": "请先选择要升级的固件",
		"updatefail": "升级失败，采集器可能离线，或者检查是否与采集器通讯正常",
		"update_suc": "升级成功",
		"deleteSuc": "删除成功",
		"debug_suc": "调试成功",
		"create": "创建",
		"addSuc": "添加数采器成功",
		"add": "添加设备",
		"addScq": "添加数采器",
		"batchAddScq": "批量添加数采器",
		"editDatalogger": "修改数采器",
		"editDataloggerName": "编辑数采器",
		"resetDataloggerName": "重置数采器",
		"unbindDataloggerName": "解绑数采器",
		"resetDataloggerExplain": "该功能主要是方便厂家清空设备上云测试数据。重置数采器后会将该设备的历史数据清空，一经操作，设备的历史数据无法恢复，请谨慎操作!",
		"unbindDataloggerExplain": "该功能主要是方便厂家进行出货前测试结束后，将测试账号(所属业主)与数采器解除绑定关系，请谨慎操作此功能，一经操作，客户需要重新绑定该数采器。",
		"rebootDataloggerName": "重启数采器",
		"rebootDataloggerSuc": "数采器重启成功",
		"fixOnRebootDataloggerName": "确认重启数采器：",
		"fixOnRebootDataloggerName1": "吗?",
		"unbindTitle": "请输入\"YES\"，确认要解除数采器与当前终端业主的绑定关系。",
		"resetTitle": "请输入\"YES\"，确认要重置数采器。",
		"editSuc": "修改数采器成功",
		"basic_info": "基本信息",
		"datalogger_pn": "数采器PN：",
		"datalogger_name": "数采器名称：",
		"nominalPower": "额定功率",
		"install_date": "安装时间",
		"installer": "安装商",
		"location_info": "位置信息",
		"location_info1": "地理信息",
		"district": "行政市区",
		"address": "数采器位置",
		"dataloggerAddress": "详细地址",
		"enterPosition": "输入数采器位置",
		"longi_lati": "经纬度",
		"latitude": "纬度",
		"longitude": "经度",
		"currentAddress": "当前地址：",
		"timezone": "时区",
		"timezone1": "所在时区",
		"cp1": "请选择安装日期",
		"cp2": "请选择时区",
		"cp3": "请输入额定功率",
		"cp4": "请选择收益币种",
		"cp5": "请输入设备名称",
		"cp6": "请选择所属项目",
		"cp7": "请选择经纬度",
		"lonRange": "经度范围为-180至180的数字",
		"latRange": "纬度范围为-90至90的数字",
		"cp9": "请输入当前地址",
		"cp10": "请输入项目名称",
		"income_info": "收益信息",
		"currency": "收益币种：",
		"buyProfit": "买电量价格：",
		"sellProfit": "卖电量价格：",
		"unitProfit": "用电量价格：",
		"generateProfit": "发电量价格：",
		"noNegative": "请输入非负数",
		"buyProfitNew": "买电量价格",
		"sellProfitNew": "卖电量价格",
		"generateProfitNew": "发电量价格",
		"add_datalogger": "新增数采器",
		"add_suc": "新增成功",
		"basicInfo": "基本信息",
		"connectionInfo": "连接信息",
		"finishAdding": "完成添加",
		"addResults": "添加结果",
		"addedSuccessfully": "添加成功",
		"finish": "完成",
		"continueAdding": "继续添加",
		"nowNoAdd": "暂不添加",
		"reAdd": "重新添加",
		"editResults": "修改结果",
		"resetResults": "重置结果",
		"unbindResults": "解绑结果",
		"delResults": "删除结果",
		"locationTip": "温馨提示：当定位不准或定位失效时可手动输入",
		"upDatalogger": "数采器升级",
		"type_code": "数采器类型编码",
		"type_name": "数采器类型名称",
		"new_type": "新增数采器类型",
		"modification_type": "修改数采器类型",
		"delete_type": "删除数采器类型编码",
		"prompt": "准备删除数采器类型编码",
		"prompt_codetip": "数采器类型编码不能为空",
		"prompt_desctip": "数采器类型名称不能为空",
		"input_prompt": "数采器类型编码为1位字母",
		"success_prompt": "新增编码成功!",
		"multi_binding": "批量绑定",
		"search_PN": "请输入PN号",
		"empty_prompt": "无数据，请输入PN号或核实PN号是否输入错误",
		"bingding_status": "绑定状态",
		"unbound": "未绑定",
		"bound": "已绑定",
		"protocol_code": "协议编码",
		"protocol_name": "协议名称",
		"bind": "绑定（修改）",
		"bind_title": "协议绑定（修改）",
		"batch_bind_title": "批量协议绑定（修改）",
		// "unbind": "解除绑定",
		"18digit": "18位绑定",
		"18digit_title": "18位协议绑定",
		"batch_protocol_binding": "批量协议绑定",
		"upload_tips": "友情提示:上传文件格式需要是xlsx,xls格式,上传文件内容,可以参考如下图",
		"disabledText": "获取数据中请稍后...",
		"disabledText1": "请选择协议",
		"upload_err": "只能上传'xlsx','xls'文件",
		"bounding_success": "绑定协议成功！",
		"unbounding_success": "解绑协议成功！",
		"unbound_tips": "是否确定要解除绑定数采器",
		"unbound_tips1": "的协议？",
		"batch_change": "批量更改",
		"batch_protocol_change": "批量协议更改",
		"dataloggerTipName": "采集器已被添加，添加人",
				"batch_edit_datalogger": "批量编辑数采器",
				"upload_column_tips": "友情提示：上传的文件A列为数采器PN,B列为带载数，C列为波特率，D列为通讯协议，E列为设备厂家编码，F列为协议厂家编码，G列为采集模式，H列为最小通讯地址，I列为最大通讯地址，不需要标题，可以参考如下图",
				"upload_csv_tips": "友情提示:上传文件格式需要是csv格式,上传文件内容,可以参考如下图",
				"click_enlarge": "点击放大查看详情",
						"collector_expire_time": "采集器到期时间",
						"collection_cycle": "采集周期",
								"ascii_display": "ASCII展示："
	},
	"map": {
		"sn": "设备SN：",
		"datalogger": "数采器名称：",
		"address": "设备地址："
	},
	"rate": {
		"device_status": "设备状态",
		"datalogger_pn": "数采器PN",
		"datalogger_pns": "数采器PN:",
		"rate_list": "费率列表",
		"datalogger_name": "数采器名称",
		"status": "状态",
		"Income_currency": "收益币种",
		"Income_currencys": "收益币种:",
		"generate_Rate": "发电量费率",
		"generate_Rates": "发电量费率:",
		"sell_Rate": "卖电量费率",
		"sell_Rates": "卖电量费率:",
		"buy_Rate": "买电量费率",
		"buy_Rates": "买电量费率:",
		"operating": "操作",
		"edit": "编辑",
		"rate": "费率",
		"cancel": "取消",
		"confirm": "确定",
		"modifySuc": "修改成功",
		"resetSuc": "重置成功",
		"unbindSuc": "解绑成功"
	},
	"auxiliary": {
		"auxiliaryFunction": "辅助功能",
		"chartSupplement": "真实图表",
		"realChart": "开启后图表显示真实数据。"
	},
	"strategy": {
		"strategyUpgrade": "升级策略列表",
		"to": "返回",
		"UpgFirmware": "本地固件管理",
		"strategyIntro": "本地升级流程概览",
		"strategyInfor": "升级策略信息",
		"strategyIntro1": "说明：该功能模块只针对蓝牙本地固件升级，若对Wi-Fi或4G等设备固件升级请移至【设备管理-设备列表-升级操作】",
		"stategyStep2": "新增固件版本包",
		"stategyStep3": "在本地固件管理中上传固件版本包文件",
		"stategyStep4": "APP本地升级",
		"stategyStep5": "策略生效后，APP收到升级提醒，可在本地进行升级",
		"stategyStep6": "新增升级策略",
		"stategyStep7": "在升级策略列表中新增策略，选中升级固件，设置升级 方式和生效，关联升级设备，生成升级策略",
		"stategyStep8": "查看升级记录",
		"stategyStep9": "查看设备升级状态和结果",
		"stategyDetail": "策略名称",
		"stategyDetail1": "升级固件",
		"stategyDetail2": "固件包大小(KB)",
		"stategyDetail3": "固件类型",
		"stategyDetail4": "波特率",
		"stategyDetail5": "升级方式",
		"stategyDetail6": "升级进度",
		"stategyDetail7": "策略状态",
		"stategyDetail8": "生效时间",
		"stategyDetail9": "失效时间",
		"upgradeList": "升级记录列表",
		"add_strategy": "升级策略列表",
		"strategy_time": "有效时间",
		"strategy_code": "策略编码",
		"strategy_name": "策略名称",
		"strategy_desc": "策略描述",
		"strategy_firmware": "升级固件",
		"strategy_type": "固件类型",
		"strategy_baudrate": "波特率",
		"uprade_type": "升级方式",
		"uprade_name": "强制升级",
		"uprade_name1": "建议升级",
		"uprade_result": "升级结果",
		"uprade_success": "升级成功",
		"uprade_fail": "升级失败",
		"uprade_status": "升级状态",
		"uprade_time": "升级时间",
		"strategy_number": "升级对象个数",
		"strategy_status": "策略状态",
		"start_time": "生效时间",
		"end_time": "失效时间",
		"edit": "编辑",
		"edit_strategy": "编辑策略",
		"view": "查看",
		"view_strategy": "查看策略",
		"cancel": "取消",
		"cancel_strategy": "取消策略",
		"force_upgrade": "强制升级",
		"suggested_upgrade": "建议升级",
		"In_effect": "生效中",
		"expired": "已失效",
		"Not_started": "未开始",
		"Not_upgraded": "未升级",
		"Yes_started": "已升级",
		"policy_information": "策略信息",
		"associated_device": "关联设备",
		"completion_strategy": "完成策略",
		"upgrade_strategy_list": "升级策略列表",
		"Next": "下一步",
		"TOP": "上一步",
		"confirm": "确认",
		"go_back": "返回",
		"strategy_detail": "策略详情",
		"strategy_search": "策略编码/策略名称",
		"strategy_upgrade_search": "设备sn/数采器pn",
		"upgrade_remind": "升级提醒",
		"remind_desc": "提醒描述",
		"default_desc": "默认描述",
		"default_desc1": "该设备需要升级到更高版本才可使用，点击'强制升级'进行升级，升级时请不要断开蓝牙连接并保证网络顺畅。",
		"message_name": "请输入策略名称",
		"message_desc": "请输入策略描述",
		"message_firmware": "请选择固件",
		"message_type": "请选择固件类型",
		"message_baudrate": "请选择波特率",
		"message_timezone": "请选择时区",
		"message_time": "请选择有效时间",
		"message_uprade_type": "请选择升级类型",
		"delete_firmware": "确定要取消此策略？",
		"delete_desc": "取消后将无法恢复，已选定的升级策略将无法通知设备进行升级",
		"Upgrade_tip": "请选择策略关联的设备",
		"Upgrade_result": "添加成功",
		"start_date": "生效日期",
		"End_date": "失效日期",
		"limits": '友情提示：上传的文件的A列为数采器PN，不需要标题，可以参考如下图',
		"mueas": '升级策略',
		"upNum": '升级设备个数',
		"deletCL": '删除策略',
		"deletCL_TEST": '确定要删除此策略？',
		"ONE_UP": '单台设备升级',
		"MO_UP": '批量设备升级',
		"MO_text": '成功导入',
		"MO_tex1": '重复的',
		"MO_tex3": '未查到',
		"MO_tex2": '台',
		"MO_tex4": '该固件包在策略中被使用，且策略未失效，该固件包无法被删除',

	},
	"cloudsUpgarde": {
		"cloudsFirmware": "云端升级固件",
		"cloudsFirmwareList": "云端升级列表"
	},
	"upgradeManagement": {
		"create": "创建",
		"cancel": "取消",
		"confirm": "确认",
		"upload_firmware": "上传固件",
		"edit_firmware": "编辑固件",
		"download_firmware": "下载固件",
		"delete_desc": "删除后将无法恢复，已选择此固件的升级策略将无法对设备进行升级",
		"eidt_success": "编辑成功",
		"delete_success": "取消成功",
		"delete_success1": "删除成功",
		"download_success": "正在下载中",
		"firmware_name": "固件包名称",
		"Firmware_Version": "版本号",
		"please_upgrade": "请选择上传文件",
		"upgrade_success": "上传固件成功",
		"please_input": "请输入",
		"Remarks": "固件描述",
		"Upload": "上传固件",
		"download_firmware_prompt": "确定要下载此固件？",
		"upgrade_file_format": "只能上传.bin/.hex格式，不可超过1MB",
		"upgrade_file_format1": "只能上传.bin/.hex格式",
		"upgrade_file_format2": "文件不可超过1MB",
		"firmwareName_empty": "固件名称不能为空",
		"firmwareVersion_empty": "版本号不能为空",
		"download_exception": "下载异常，请稍后再试",
		"upload_result": "上传结果",
	},
	"project": {
		"choice": "筛选",
		"move": "移动",
		"manageProject": "项目管理",
		"project": "所属项目",
		"defaultProject": "默认项目",
		"projectName": "项目名称",
		"projectRemark": "项目描述",
		"projectId": "项目ID",
		"createProject": "新建项目",
		"createResults": "新建结果",
		"createSuc": "新建成功",
		"editProject": "编辑项目",
		"editResults": "编辑结果",
		"editSuc": "编辑成功",
		"delProject": "删除项目",
		"delResults": "删除结果",
		"delSuc": "删除成功",
		"upgradeResults": "升级结果",
		"upgradeSuc": "升级成功",
		"back": "返回",
		"placeholder": "搜索设备名称PN/SN",
		"modifySuc": "成功",
		"upload": "上传图片",
		"limit": "(图片大小不超过1M)",
		"moveTo": "移动至",
		"moveSelect": "移动所选",
		"deviceSn": "设备SN",
		"tipCard": "卡片",
		"tipList": "列表",
		"tipSearchSN": "按设备搜索",
		"tipSearchPN": "按数采器搜索",
		"energyCurrent": "当前功率",
		"energyDate": "当日发电量",
		"energyMonth": "当月发电量",
		"energyYear": "当年发电量",
		"energyTotal": "总发电量"
	},
	"constant": {
		"renminbi": "人民币(￥)",
		"meiyuan": "美元($)",
		"ouyuan": "欧元(€)",
		"aoyuan": "澳元($A)",
		"yingbang": "英镑(£)",
		"gangbi": "港币(HK$)",
		"ruidian": "瑞典克朗(Kr)",
		"lubi": "印度卢比(₹)",
		"moxige": "墨西哥比索(Mex$)",
		"baxi": "雷亚尔(R$)",
		"Pakistani": "巴基斯坦卢比(Rs)",
		"Rand": "南非兰特(R)",
		"gmt0": "(GMT +00:00)都柏林,爱丁堡,里斯本,伦敦,卡萨布兰卡,协调世界时",
		"gmt_1": "(GMT +01:00)巴黎,马德里,哥本哈根,罗马,维也纳,柏林,阿姆斯特丹,中非西部",
		"gmt_2": "(GMT +02:00)安曼,大马士革,开罗,雅典,耶路撒冷,伊斯坦布尔",
		"gmt_3": "(GMT +03:00)巴格达,科威特,利雅得,内罗毕,德黑兰",
		"gmt_4": "(GMT +04:00)阿布扎比,马斯喀特,埃里温",
		"gmt_5": "(GMT +05:00)伊斯兰堡,卡拉奇",
		"gmt_55": "(GMT +05:30)新德里",
		"gmt_6": "(GMT +06:00)达卡,阿斯塔纳,叶卡捷琳堡",
		"gmt_65": "(GMT +06:30)缅甸",
		"gmt_7": "(GMT +07:00)曼谷,河内,雅加达,新西伯利亚",
		"gmt_8": "(GMT +08:00)北京,重庆,香港特别行政区,乌鲁木齐,台北,吉隆坡,新加坡",
		"gmt_9": "(GMT +09:00)大阪,东京,首尔",
		"gmt_10": "(GMT +10:00)布里斯班,关岛,堪培拉,墨尔本,悉尼",
		"gmt_11": "(GMT +11:00)所罗门群岛,符拉迪沃斯托克,新喀里多尼亚",
		"gmt_12": "(GMT +12:00)奥克兰,惠灵顿,斐济,马加丹",
		"gmt_13": "(GMT +13:00)努库阿洛法",
		"gmt_neg_1": "(GMT -01:00)佛得角群岛,亚速尔群岛",
		"gmt_neg_2": "(GMT -02:00)中大西洋",
		"gmt_neg_3": "(GMT -03:00)巴西利亚,布宜诺斯艾利斯,格陵兰,卡宴",
		"gmt_neg_4": "(GMT -04:00)大西洋时间(加拿大),库亚巴,拉巴斯,圣地亚哥",
		"gmt_neg_5": "(GMT -05:00)东部时间(美国和加拿大),印第安纳州(东部)",
		"gmt_neg_6": "(GMT -06:00)中部时间(美国和加拿大),中美洲,墨西哥城,蒙特雷,瓜达拉哈拉",
		"gmt_neg_7": "(GMT -07:00)山地时间(美国和加拿大),奇瓦瓦,拉巴斯,马萨特兰,亚利桑那",
		"gmt_neg_8": "(GMT -08:00)太平洋时间(美国和加拿大),下加利福利亚州",
		"gmt_neg_9": "(GMT -09:00)阿拉斯加",
		"gmt_neg_10": "(GMT -10:00)夏威夷",
		"gmt_neg_11": "(GMT -11:00)萨摩亚群岛",
		"gmt_neg_12": "(GMT -12:00)国际日期变更线西"
	},
	"basic": {
		"modifySuc": "修改成功!",
		"Personal_info": "信息修改",
		"User_name": "用户名：",
		"User_name1": "用户名",
		"Nickname": "昵称：",
		"Nickname1": "昵称",
		"editNickname": "修改昵称",
		"Ple_Nickname": "请输入昵称",
		"setNickname": "设置昵称",
		"Email": "邮箱：",
		"Email1": "电子邮箱",
		"Email2": "电子邮箱：",
		"editEmail": "更换电子邮箱",
		"setEmail1": "绑定电子邮箱",
		"Mobile": "手机号码：",
		"Mobile1": "手机号码",
		"editMobile": "更换手机号码",
		"setMobile": "绑定手机号码",
		"Avatar": "用户图片",
		"basic": "个人信息",
		"Save": "保存",
		"Select_all": "恢复全选",
		"Ple_phone": "请输入要绑定的手机号",
		"code": "验证码：",
		"Ple_code": "请输入验证码",
		"Obtain_code": "获取验证码",
		"Bind_phone": "绑定手机",
		"After_bindingPh": "绑定手机后,可通过手机找回密码",
		"Untie_phone": "解绑手机",
		"Change_phone": "更换手机",
		"Bind_email": "绑定邮箱",
		"Ple_email": "请输入要绑定的邮箱",
		"re_enter": "再次获取",
		"After_bindingEm": "绑定邮箱后,可通过邮箱找回密码",
		"Unbind_email": "解绑邮箱",
		"Change_email": "更换邮箱",
		"unbind_Ph": "确定解绑手机号吗？",
		"unbinding_Ph": "解绑后将无法使用该手机找回密码!",
		"unbind_Em": "确定解绑邮箱吗？",
		"unbinding_Em": "解绑后将无法使用该邮箱找回密码!",
		"mobile_code": "验证码已经发送到您的手机，请注意查收",
		"email_code": "验证码已经发送到您的邮箱，请注意查收",
		"suc_ph": "绑定手机号成功",
		"suc_em": "绑定邮箱成功",
		"code_frequently": "验证码发送频繁，请稍后再试",
		"personalCenter": "账号设置",
		"basicInfo": "基本信息",
		"accountSecurity": "账户安全",
		"backTo": "返回",
		"uploadAvatar": "更换头像",
		"bindPhone": "手机绑定",
		"bindEmail": "邮箱绑定",
		"changePwdTip": "安全性高的密码可以使账号更安全。建议您定期更换密码，设置一个6~32位的密码。",
		"bindPhoneTipBefore": "已绑定手机：",
		"bindEmailTipBefore": "已绑定邮箱：",
		"bindPhoneTip": "设置一个手机，可以登录及找回密码，接收系统发送的通知。",
		"bindEmailTip": "设置一个邮箱，可以登录及找回密码，接收系统发送的通知。",
		"bindPhoneTipAfter": "，可以登录及找回密码，接收系统发送的通知。",
		"changeBtn": "修改",
		"changePwd": "修改密码",
		"changePwdSuc": "重置密码成功",
		"finished": "完成",
		"retry": "重试",
		"changeRes": "修改结果",
		"bindRes": "绑定结果",
		"noHanzi": "密码不能包含中文",
		"Nickname_length_tip": "用户昵称长度为2~32位"
	},
	"password": {
		"User_name": "用户名：",
		"Password": "密码修改",
		"Current_password": "旧密码：",
		"New_password": "新密码：",
		"Config_newpassword": "确认新密码：",
		"PLCurrent_password": "请输入旧密码",
		"PLNew_password": "请输入新密码",
		"PLConfig_newpassword": "请确认新密码",
		"editPwdSuc": "修改密码成功!",
		"loginAgain": "修改密码成功，请重新登录",
		"Save": "保存"
	},
	"settingalarm": {
		"chosesstation": "请选择电站",
		"addEmails": "增加邮箱",
		"delete": "删除邮箱成功",
		"deletes": "删除",
		"Email_List": "邮件列表",
		"Add_Mailbox": "新增邮箱推送",
		"cancel": "取消",
		"Add": "增加",
		"Email_Setting": "邮件推送设置",
		"Alarm_Type": "告警类型：",
		"Warning": "告警",
		"Error": "错误",
		"Fault": "提醒",
		"Receiving_Report": "报表管理",
		"Daily_Report": "日报表",
		"Monthly_Report": "月报表",
		"Yearly_Report": "年报表",
		"Receiving_Plant": "推送的电站：",
		"E_Mail": "邮箱：",
		"Email": "邮箱",
		"Plant": "关联电站",
		"Operation": "操作",
		"Alarm_Typetabel": "告警类型",
		"Yes": "是",
		"No": "否",
		"Delete": "删除",
		"suredelete": "是否确定要删除此邮箱推送？",
		"Delete_Mailbox": "删除邮箱",
		"Add_suc": "新增推送邮箱成功!",
		"create": "创建",
		"list": "序号",
		"edit": "编辑"
	},
	"recharge": {
		"Datalogger_List": "数采器列表",
		"Datalogger_PN": "数采器PN号",
		"DataloggerPN": "PN：",
		"DataloggerName": "别名",
		"CCID": "流量卡卡号",
		"CCID_time": "流量卡到期时间",
		"Plant": "电站名称",
		"Connecting_Devices": "带载数",
		"Status": "流量卡状态",
		"Signal": "信号值",
		"Activation_Time": "激活时间",
		"Dead_Time": "失效时间",
		"Operation": "操作",
		"Recharge_record": "充值记录",
		"Time": "充值时间",
		"Order_Number": "订单号",
		"Rcharge_Month": "充值月数",
		"Recharge_money": "充值金额",
		"rechargeStatus": "充值状态",
		"Unpaid": "未付款",
		"Paid": "已付款",
		"Recharge_successful": "充值成功",
		"Recharge_fail": "充值失败",
		"Recharging": "充值中",
		"normal": "正常",
		"warning": "预警",
		"Overdue": "已逾期",
		"expired": "已失效",
		"unknown": "未知",
		"Recharge_status": "充值状态",
		"ccid": "数采器流量卡卡号",
		"Traffic_status": "流量状态",
		"Recharge": "充值",
		"Recharge1": "流量充值",
		"load": "带载数",
		"pn": "数采器PN号",
		"serial_number": "序号",
		"rechargeErr": "请选择带载数相同的数采器",
		"rechargeDevice": "充值设备：",
		"rechargePackage": "充值套餐：",
		"rechargeChannel": "充值方式：",
		"rechargePrice": "充值金额：",
		"rechargeDiscount": "优惠金额：",
		"scan": "扫一扫付款",
		"openWx": "请打开手机微信",
		"scanComplete": "扫一扫完成支付",
		"previous": "返回",
		"rechargeSuc": "支付成功",
		"rechargeSucInfo": "您已支付成功，流量将于24小时内到账",
		"orderno": "订单号",
		"Recharged": "充值成功",
		"Recharge_List": "充值列表",
		"not_for_the_time_being": "暂不处理",
		"Recharge_now": "立即充值",
		"early_warning": "流量卡到期预警",
		"Content_warning": "尊敬的用户您好！发现您所使用设备的流量卡即将到期，如未及时充值，则会造成该流量卡被运营商注销且不能继续使用。为了不影响您的正常使用，请及时对预警状态的设备进行充值！",
		"Recharge_reminder": "充值提醒",
		"Recharge_Selected": "充值",
		"Search": "搜索",
		"cancel": "取消",
		"confirm": "确定",
		"rechMoney": "支付",
		"rechDiscount": "已优惠",
		"rechScan": "请打开手机微信扫一扫完成支付",
		"rechTip": "温馨提示：1、同一订单只能选择相同卡类型(如4G国内)、相同带载数和相同扶贫平台状态的设备(默认显示带载数为1和未接入扶贫平台的套餐)；2、充值逾期卡和在每月25号至5号进行充值都会延迟1~14天到帐，请耐心等待",
		"Hint_language": "您的设备存在2G设备。应工信部要求2G逐步退网，建议购买更换4G设备！",
		"Tips": "提示",
		"Confirm_recharge": "确认充值",
		"Cancel_recharge": "取消充值",
		"Hint_language1": "您在充值中遇到问题，请联系售后服务热线0755—89993588",
		'recharge_type': "类型",
		'Service_Area': "服务区域",
		'Package_type': "套餐类型",
		'domestic': '国内',
		'abroad': '国外',
		'Recharge_tip': '充值提醒',
		'Recharge_tip1': '仅支持相同类型的卡进行批量充值',
		'Recharge_tip2': '请选择例如：相同带载数为 1；相同卡类型 为 4G ；相同区域为大陆中国 流量卡进行批量充值',
		'Recharge_tip3': '推荐已经安装微信用户使用',
		'Recharge_tip4': '推荐已注册Pay pal的用户使用',
		'Recharge_tip5': '微信支付',
		'Recharge_tip6': '存在不支持充值的卡，请联系管理员',
		'area_domestic': '中国大陆',
		'area_abroad': '国际',
				'remedy_title': '充值订单补救',
				'upload_tip': '友情提示:上传文件格式为.txt'
	},
	"customize": {
		"switchSkin": "皮肤切换",
		"classic": "粉红",
		"purple": "紫色",
		"blue": "经典蓝",
		"orange": "甜甜橙",
		"green": "清新绿"
	},
	"firmware": {
		"Firmware_limit_format": "只能上传\".bin\"和\".hex\",\".s19\"格式的文件",
		"Firmware_upload_fail": "上传失败，请重新上传！",
		"Firmware_upload_failTip": "上传失败",
		"Firmware_limit1": "最多只能上传",
		"Firmware_limit2": "个",
		"Firmware_limit3": "固件",
		"Firmware_limitM": "单个固件大小不能超过",
		"Firmware_Name": "固件名称",
		"Firmware_desrc": "固件描述",
		"Size": "固件大小(KB)",
		"Upload_Time": "上传时间",
		"Operation": "操作",
		"Firmware_List": "固件管理",
		"Firmware_Lists": "固件列表",
		"Add_Firmware": "添加固件",
		"deleteFirmware": "删除",
		"Firmware_Version": "版本号",
		"editFirmware": "编辑",
		"downloadFirmware": "下载",
		"tips": "提示",
		"noRecord": "无记录",
		"delete_firmware": "确定要删除此固件？",
		"del_firmware": "删除固件",
		"firmware_upgrade": "固件升级",
		"uploadTips": "请上传固件文件",
		"cancel": "取消",
		"confirm": "确定",
		"Upload_firmware": "上传固件",
		"Firmware_description": "固件描述：",
		"enter_content": "请输入内容",
		"Select_file": "选取文件",
		"limit": "只能上传\".bin\"和\".hex\"格式的文件，且不超过8M",
		"limit0": "只能上传\".bin\"和\".hex\",\".s19\"格式的文件，且不超过8M",
		"limit1": "只能上传\"xlsx\"格式的文件",
		"limit2": "友情提示：上传的文件的A列为数采器PN，B列为数采器别名，不需要标题，可以参考如下图。",
		"limit3": "添加成功",
		"error1": "只能上传\".bin\"和\".hex\",\".s19\"格式的文件",
		"error2": "请按LFU按钮",
		"deleteSuc": "删除成功",
		"UploadTitle": "请上传批量文件",
		"Upload": "上传固件",
		"Upload1": "上传文件",
		"upgrade_quit1": "升级异常，已退出!",
		"upgrade_quit2": "升级失败,请稍后再试!",
		"upgrade_quit3": "升级成功",
		"upgrade_quit4": "升级被手动取消",
		"upgrade_quit5": "未在升级中",
		"upgrade_quit6": "取消升级",
		"upgrade_quit7": "升级失败",
		"upgrade_quit8": "升级异常",
		"upgrading": "升级中",
		"upgrading1": "升级连接中，请稍等",
		"updateCompleted": "升级完成",
		"CancelUpgradeSuc": "取消升级成功",
		"FailedCancelUpgrade": "取消升级失败",
		"CancelUpgradeSuc11": "取消升级成功，请等待采集器连接云端后再升级",
		"upgrade_wait": "升级准备中，请稍等1-2分钟",
		"upgrade_wait1": "升级准备完成，请等待数采器上线后再次启动升级任务",
		"colOffline": "数采器不在线",
		"colUpgrading": "已经在升级中",
		"UpgradeStarting": "升级启动中，请稍候...",
		"upgradeSq_fail": "数采器升级失败，请稍后再试！",
	},
	"browse": {
		"usr": "子账户",
		"email": "邮箱",
		"mobile": "手机",
		"gts": "注册日期",
		"desc": "备注",
		"enableStatus": "启用状态",
		"Enable": "启用",
		"Disable": "禁用",
		"addBrowse": "添加子账户",
		"pleaseUsr": "请输入子账户",
		"accountInfo": "账号信息",
		"username": "用户名",
		"password": "密码",
		"newPassword": "新密码",
		"confirmPassword": "确认密码",
		"usrInfo": "用户信息",
		"device": "项目选择",
		"pleaseDevice": "选择项目",
		"pleaseDevice_title": "请选择项目",
		"pleaseStatus": "选择状态",
		"addSuccess": "添加子账户成功",
		"editSuccess": "编辑子账户成功",
		"editBrowse": "编辑子账户",
		"deleteSuccess": "删除成功",
		"deleteBrowse": "删除",
		"delete_browse": "确定删除子账户吗？",
		"please_browsepwd": "请检查新密码和确认密码输入要求"
	},
	"retrieve": {
		"Retrieve_password": "找回密码",
		"Retrieve_passwordPhone": "手机找回密码",
		"Retrieve_passwordEmail": "邮箱找回密码",
		"passwordEmail": "未绑定邮箱",
		"passwordEmail1": "邮箱不匹配",
		"passwordPhone": "未绑定手机号码",
		"passwordPhone1": "手机号码不匹配",
		"login": "登录",
		"signup": "注册",
		"Enter_account": "输入账号",
		"Verify_identidy": "验证身份",
		"reset_Password": "重置密码",
		"finish": "完成",
		"account_password": "请输入您所需要找回密码的账号",
		"username": "用户名",
		"Verification_code": "验证码",
		"phone_number": "手机号",
		"new_password": "新的登录密码",
		"Con_password": "确认新的密码",
		"enter_name": "请输入用户名",
		"enter_code": "请输入验证码",
		"Change_one": "换一张",
		"confirm": "确认",
		"bound_mobile": "请输入绑定手机号码",
		"Email_verification": "邮箱验证",
		"Obtain_code": "获取验证码",
		"code_1minute": "验证码已发送到您的手机，1分钟内输入有效.",
		"Email": "邮箱",
		"bound_email": "请输入绑定邮箱",
		"Phone_verification": "手机验证",
		"code_5minutes": "验证码已发送到您的邮箱，5分钟内输入有效.",
		"New_password": "新的登录密码",
		"Confirm_password": "确认新的密码",
		"Reset_successfully": "重置密码成功,请牢记您的新密码",
		"re-register": "重新登录",
		"Incorrect_code": "验证码不正确",
		"email_first": "请先填写邮箱",
		"mobile_first": "请先填写手机号码",
		"Reset_passwordSuc": "重置密码成功",
		"Get_codeSucc": "获取验证码成功",
		"Getting_progress": "正在获取中,请稍等!",
		"Newloginpassword": "新的登录密码",
		"Confirmloginpassword": "确认新的登录密码",
		"step1": "步骤1",
		"step2": "步骤2",
		"step3": "步骤3",
		"step4": "步骤4"
	},
	"errCode": {
		"0": "正常, 无错误",
		"1": "失败",
		"2": "超时，系统繁忙，请稍后再试",
		"3": "系统异常，请联系管理员",
		"4": "请勿输入特殊字符（无法验证的签名）",
		"5": "盐值错误, 未按规则使用",
		"6": "参数格式错误",
		"7": "缺少必要的参数",
		"8": "平台拒绝",
		"9": "不支持的操作",
		"10": "未通过认证，请重新登录",
		"11": "无权限的操作",
		"12": "无记录",
		"13": "超出限制",
		"14": "重复的操作",
		"15": "没有找到厂家key",
		"16": "密码错误",
		"17": "密码格式错误",
		"18": "手机号已绑定，请更换手机号或解除绑定",
		"19": "电话号码格式错误（6<=号码长度<32）",
		"20": "邮箱格式错误（6<=邮箱长度<64，并包含@符号）",
		"21": "用户名格式错误（2<=用户名长度<32）",
		"22": "公司名称格式错误",
		"23": "厂家编码无效，请验证编码是否填写正确",
		"24": "用户名已存在",
		"25": "账户已被禁用，请联系管理员",
		"26": "邮箱已绑定，请更换邮箱，或解除绑定",
		"27": "账户已被注销，请联系管理员",
		"256": "无数据",
		"257": "无数采器",
		"258": "无设备",
		"259": "无效PN号,请核对PN号是否正确",
		"260": "无电站",
		"261": "找不到用户",
		"262": "设备已离线",
		"263": "数采器已离线",
		"264": "无设备告警",
		"265": "无环境检测仪",
		"271": "无任何修改操作",
		"272": "重复绑定",
		"273": "不支持添加其他厂家的数采器",
		"276": "不支持移动含有其他厂家的数采器的电站业主",
		"288": "无摄像头",
		"352": "无固件",
		"353": "无协议",
		"368": "无角色",
		"369": "无用户分组",
		"370": "无电站分组",
		"371": "无GPRS流量充值套餐",
		"372": "无GPRS流量充值订单",
		"384": "验证码输入错误",
		"385": "无device_token",
		"386": "无设备配置信息",
		"387": "无数采器类型",
		"512": "短信验证码不匹配",
		"513": "短信验证码超时",
		"514": "电话号码/邮箱未绑定",
		"515": "电话号码/邮箱不匹配",
		"516": "名称不能同名",
		"517": "用户或电站下还存在数采器",
		"518": "用户还存在下属用户",
		"519": "用户名已存在",
		"520": "PN号重复",
		"521": "数采器不属于该用户",
		"522": "数采器已存在",
		"523": "不是浏览者账号",
		"525": "验证码已发送，请稍候再试",
		"528": "该角色已绑定用户，无法删除",
		"768": "协议中没有可选字段",
		"772": "采集器已被绑定",
		"1024": "只支持电站业主",
		"1025": "只支持管理员",
		"1026": "只支持设备厂家",
		"1027": "上级用户需要是管理员或设备厂家",
		"1028": "不支持的充值方式",
		"1029": "重复的数采器编号",
		"1030": "无效的GPRS卡",
		"1031": "用户不是该管理员创建",
		"1041": "key已失效或找不到",
		"1042": "无效的CCID",
		"1792": "数采器必须都属于该管理员"
	},
	"controlDeviceErrCode": {
		"1": "操作失败，请检查设备后再试！",
		"2": "响应超时，请重试！",
		"3": "系统异常，请联系管理员",
		"6": "格式错误,请联系管理员",
		"8": "拒绝,请联系管理员",
		"9": "不支持操作,请联系管理员",
		"11": "无权限,请联系管理员",
		"263": "当前数采器处于离线状态，请设备上线后再试！"
	},
	"control": {
		setting: "下发",
		TouSetting: "系统工作模式设置",
		touCharge: "充电优先",
		touPersonal: "自发自用",
		touComplete: "全额上网",
		touClipping: "削峰填谷",
		touOffgrid: "离网应用",
		confirmModeSwitch: "是否切换模式",
		modeSwitch: "切换模式",
		startTime: "开始时间",
		endTime: "结束时间",
		paramValue: "请选择参数值",
		Monday: "周一",
		Tuesday: "周二",
		Wednesday: "周三",
		Thursday: "周四",
		Friday: "周五",
		Saturday: "周六",
		Sunday: "周日",
		syncSetDay: "同步下发至每日",
		time: "时间段1",
		time1: "时间段2",
		time2: "时间段3",
		time3: "时间段4",
		time4: "时间段5",
		time5: "时间段6",
		setFail: "下发失败",
		readFail: "读取失败",
		charge: "充电",
		discharge: "放电",
		reading: "读取成功",
		reading_loading: "读取中...",
		pvMode: "馈网模式",
		"screenshot": "截图",
	},
	"CollectorCountByOMSOrder": {
		"1": "操作失败",
		"7": "缺少必要的参数",
		"8": "拒绝,请联系管理员",
		"12": "订单下无有效采集器PN号,请确认订单号",
		"23": "厂家编码无效，请联系管理员",
		"259": "该订单下有无效采集器，请联系管理员",
		"261": "无法找到所分配的经销商，请联系管理员",
		"772": "该订单已有采集器被绑定,请确认订单中的采集器未被绑定"
	},
	"message": {
		"uname_is_required": "账号不能为空",
		"id_is_required": "分组不能为空",
		"pwd_is_required": "密码不能为空",
		"confpwd_is_required": "确认密码不能为空",
		"invitation_is_required": "体验码不能为空",
		"pwdAgain": "请再次输入密码",
		"pwdSame": "新旧密码不能相同",
		"oldPass_wrong": "旧密码错误，请重新输入",
		"pwdNotsame": "两次输入密码不一致",
		"email_is_required": "邮箱不能为空",
		"email_info": "64个字符以内正确邮箱地址",
		"mobile_is_required": "手机号不能为空",
		"pn_is_required": "PN不能为空",
		"PN_info": "PN号长度为14位或18位，首位为大写字母,仅包含大写英文和数字",
		"nodata": "无数据",
		"length2_64": "长度在 2 到 64 个字符",
		"length2_32": "长度在 2 到 32 个字符",
		"length6_20": "只能输入6-20个字母、数字、下划线",
		"length6_32": "长度在 6 到 32 个字符",
		"delete_plant": "删除电站",
		"modify_plant": "修改电站",
		"Exporting_the_report": "导出报表",
		"cancel": "取消",
		"search": "搜索",
		"Logging_off": "该账号处于注销中，无法登录",
		"country_is_required": "请选择国家或地区",
	},
	"report": {
		"Export_report": "导出报表",
		"Subscribe_report": "订阅报表",
		"all_reports": "导出所有",
		"Report_type": "报表类型:",
		"Daily_report": "日报表",
		"Monthly_report": "月报表",
		"Yearly_Report": "年报表",
		"Total_report": "总报表",
		"customize": "自定义",
		"Report_date": "报表日期:",
		"Report_date1": "注:导出日期的范围不可超过31天",
		"select_date": "请选择日期",
		"select_month": "请选择月份",
		"to": "至",
		"start_date": "开始日期",
		"End_date": "结束日期",
		"cancel": "取消",
		"Export": "导出",
		"download": "正在进行下载中，请稍等",
		"Batch_export": "批量导出",
		"current": "此刻",
		"no_deAlarm": "最近一个月未发生设备告警",
		"Export_alarm": "导出告警"
	},
	"actionLog": {
		"index": "序号",
		"date": "日期",
		"user": "用户",
		"acitonDesc": "动作描述",
		"startTime": "开始时间",
		"endTime": "结束时间",
		'userNote': '请输入用户名',
		"userName": "用户名",
		'uidNote': '请输入UID',
		'PNNote': '请输入PN号',
		'actionNote': '请输入接口action',
		'All': '所有'
	},
	"factory": {
		"name": "厂家名称",
		"code": "厂家编码",
		"time": "生成时间",
		"append": "新增厂家编码",
		"amend": "修改厂家编码",
		"delete": "删除厂家编码",
		"delete_warn": "厂家编码确认删除吗？",
		"input_tip": "厂家编码为2-3位数字或字母",
		"error_tip": "输入错误",
		"right_tip": "输入正确",
		"editSuc": "修改完成",
		"prompt_codeTip": "厂家编码不能为空",
		"prompt_nameTip": "厂家名称不能为空",
		"ID": "厂家ID",
		"acount": "厂家账号",
		"usrName": "账户名",
		"acountType": "账户类型",
		"isEnabled": "是否启用",
		"chooseIsEnabled": "请选择是否启用",
		"enabled": "已启用",
		"disabled": "未启用",
		"visibleDevcode": "可见设备编码",
		"pwd": "密码",
		"accountInfo": "账号信息",
		"comfirmPwd": "确认密码",
		"factoryInfo": "厂家信息",
		"devcode": "设备编码",
		"devcode_is_requeired": "设备编码不能为空",
		"confirmDelete": "确定删除",
		"confirmDelete1": "厂家吗？",
		"ecoin": "E币"
	},
	"keyList": {
		"companyName": "公司全称",
		"version_number": "版本号",
		"client": "客户端",
		"domainName": "域名全称",
		"contact_information": "联系方式",
		"key": "key",
		"describe": "描述",
		"unseal": "是否开启",
		"platform": "平台",
		"companyNameTips": "公司名称不能为空",
		"domainNameTips": "域名全称不能为空",
		"version_numberTips": "版本号不能为空",
		"contact_informationTips": "联系方式不能为空",
		"clientTips": "平台不能为空",
		"keyTips": "key不能为空",
		"keyTips2": "十六字节长度的key",
		"describeTips": "描述不能为空",
		"unsealTips": "是否开启不能为空",
	},
	"protocol": {
		"pn": "PN号",
		"postal_address": "通讯地址",
		"Protocol_encoding": "协议编码",
		"date": "日期",
		"Please_date": "请选择日期",
		"Protocol_instructions": "协议指令",
		"Query_Results": "查询结果",
		"query": "查询",
		"CRC_verification": "CRC校验",
		"Length_verification": "长度校验",
		"Data_index": "数据下标",
		"raw_data": "原始数据",
		"verification_results": "CRC校验结果",
		"agreement": "一致",
		"atypism": "不一致",
		"verification_result": "长度校验结果",
		"Analysis_results": "解析结果",
		"Please_results": "请先获取查询结果",
	},
	"rawData": {
		"pn": "PN号",
		"Equipment_number": "设备序列号",
		"Equipment_coding": "设备编码",
		"Device_address": "设备地址",
		"date": "日期",
		"Please_date": "请选择日期",
		"encrypted": "是否加密",
		"Please_type": "请选择加密类型",
		"yes": "是",
		"no": "否",
		"raw_data": "原始数据",
		"analysis": "解析",
	},
	"collectionFrequencyUP": {
		"collect_fast": "能流参数加速",
		"collect_fast2": "能流加速",
		"collect_fast_fail": "本次加速失败，请重试",
		"collect_fasting": "能流参数加速中",
		"collect_fast_starting": "加速启动中",
		"collect_fast1": "数据明细加速",
		"collect_fast1ing": "数据明细加速中",
		"paySecCon": "支付确认",
		"energyFetchPic": "是否确认充值,充值的加速范围为能量流图页面参数如下图",
		"historyFetchPic": "是否确认充值,充值的加速范围为数据明细页面参数如下图",
		"reRechargeTip1": "当前设备已购买能流加速服务。继续购买将再次产生费用，是否继续？",
		"reRechargeTip": "当前设备已购买明细加速服务。继续购买将再次产生费用，是否继续？",
		"continueRecharge": "继续充值",
		"collect_fasting_title": "实时参数不存储",
		"collect_Order_Record": "加速充值记录",
		"collect_recharge": "采集加速充值（数据明细加速）",
		"collect_recharge1": "采集加速充值（能流加速）",
		"Package": "加速套餐",
		"every_interval": "当前选中的加速规格为:每间隔",
		"gather": "采集",
		"Once": "次",
		"Payment_method": "支付方式",
		"Online_payment": "在线支付",
		"Recharge_now": "立即充值",
		"have_read": "我已充分阅读",
		"Collection_terms": "采集频率加速充值条款",
		"Purchase_Terms": "购买条款",
		"Purchase_Terms1": "采集加速有效期",
		"Purchase_Terms2": "采集加速服务的到期时间将根据您购买的套餐时长自动计算。具体到期时间以页面展示为准",
		"Purchase_Terms3": "不能自定义对部分参数进行采集频率升级么",
		"Purchase_Terms4": "请期待我们的新版本，当前版本仅支持对所有显示参数进行采集升级，给您带来的不便请谅解!",
		"Purchase_Terms5": "套餐价格",
		"Purchase_Terms6": "我们的收费是根据您的参数数量、加速的采集频率、带载数 综合计算得出的最终价格;历史数据除上述条件还涉及存储时间",
		"Purchase_Terms7": "还有其他疑问",
		"Purchase_Terms8": "若您还有其他疑问可联系我们的在线客服进行咨询，我们将会详细为您解答",
		"Collect_terms": "采集加速充值条款",
		"Collect_terms1": "采集频率服务加速服务条款",
		"Collect_terms2": "一、套餐的适用范围",
		"Collect_terms3": "适用于您充值的采集器使用的协议内包含的显示参数(注:若您选择的是能流图页面进行加速充值，套餐的适用范围只限于能流图页面的显示参数范围;若您选择的历史数据页面进行加速充值，套餐适用的范围仅限于历史数据页面显示参数范围)",
		"Collect_terms4": "二、不支持更换协议/设备",
		"Collect_terms5": "更换协议/设备不参与加速享用",
		"Collect_terms6": "三、套餐的退订",
		"Collect_terms7": "付费后不支持退订和变更",
		"Collect_terms8": "四、套餐价格",
		"Collect_terms9": "我们的收费是根据您的参数数量、加速的采集频率、带载数 综合计算得出的最终价格;历史数据除上述条件还涉及存储时间",
		"Collect_terms10": "五、流量消耗",
		"Collect_terms11": "采集频率加速会加剧流量消耗",
		"Scan_payment": "扫码支付",
		"Recharge_result": "充值结果",
		"Recharge_successful": "充值成功",
		"Recharge_successful_next": "恭喜您充值成功，我们即将为您升级采集频率，您可以从此刻关注您的采集频率变化",
		"Order_No": "订单号",
		"Recharge_time": "充值时间",
		"Recharge_amount": "充值金额",
		"view_order": "查看订单",
		"Recharge_failed": "充值失败",
		"Recharge_failed_next": "很抱歉充值失败，您可以尝试重新支付",
		"PN_order": "PN/订单号",
		"View_Details": "查看明细",
		"Type": "充值类型",
		"Real_parameters": "实时参数",
		"History_Data": "历史数据",
		"acquisition_frequency": "采集频率",
		"device_Info": "设备信息",
		"noRecharg": "采集器不支持充值",
		"noRecharg_min": "你的采集速度已经达到最快啦！",
		"noRecharg_wifi": "当前版本仅支持Wi-Fi模块数采器",
		"paypalTip": "最终支付金额以PayPal为准",
		"upPrice": "补差价",
	},
	alarmNew: {
		'fileName': '文件名',
		'fileSize': '文件大小',
		'fileStatus': '文件状态',
		'progress': '进度',
		'can': '可下载',
		'no': '导出中',
		'history': '导出历史',
		'brand3-list': '一体机列表'
	},
	shuoriExport: {
		"exportRecords": "导出记录",
		"export": "导出",
		"exportTask": "导出任务已创建，请稍后在导出记录中下载",
		"noDownload": "文件地址无效或无法下载,请重试",
		'data': '日期',
	},
	colUnBindRecord: {
		'UnBindRecord': '数采器解绑记录',
		'unStatus': '解绑状态',
		'unScene': '解绑场景',
		'oldUser': '原用户',
		'newUser': '新用户',
		'unCount': '解绑次数',
		'pnBarCode': '条形码',
		'devicePicture': '设备实物',
		'ip': '解除IP',
		'unTime': '解绑时间',
	},
	rosRecharge: {
		'electronicInvoicing': '电子开票',
		'issueEInvoice': '开电子发票',
		'invoiceHistory': '开票历史',
		'rechargeDuration': '充值时长',
		'year': '年',
		'month': '月',
		'day': '日',
		'days': '天',
		'pendingPayment': '待支付',
		'paymentSuccess': '支付成功',
		'paymentFailed': '支付失败',
		'orderClosed': '订单关闭',
		'serviceTerminated': '服务终止',
		'unpaid': '未支付',
		'paying': '支付中',
		'paid': '已支付',
		'refunded': '已退款',
		'cancelled': '已取消',
		'rechargeSuccess': '充值成功',
		'rechargeFailed': '充值失败',
		'pleaseSelectDate': '请选择日期',
		'orderNo': '订单号',
		'batchInvoicing': '批量开票',
		'rechargeType': '充值类型',
		'trafficRecharge': '流量充值',
		'collectRecharge': '采集充值',
		'rechargeStatus': '充值状态',
		'invoice': '开票',
		'invoiceStatus': '发票状态',
		'invoiceTime': '开票时间',
		'viewDetail': '查看详情',
		'invoicing': '开票中',
		'invoiceSuccess': '开票成功',
		'invoiceFailed': '开票失败',
		'issueElectronicInvoice': '开电子发票',
		'invoiceType': '发票类型',
		'generalInvoice': '普通发票',
		'specialInvoice': '专用发票',
		'headerType': '抬头类型',
		'companyHeader': '公司抬头',
		'personalHeader': '个人/非企业抬头',
		'pleaseInputCompanyHeader': '请填写公司抬头',
		'taxNumber': '公司税号',
		'pleaseInputTaxNumber': '请填写纳税人识别号',
		'headerName': '抬头名称',
		'suggestPersonalName': '建议填写个人姓名/店名',
		'invoiceContent': '发票内容',
		'internetCommService': '物联网通讯服务费',
		'invoiceAmount': '开票金额',
		'yuan': '元',
		'moreInfo': '更多信息',
		'remarkAddressEtc': '备注、地址等',
		'companyAddress': '公司地址',
		'pleaseInputCompanyAddress': '请输入公司地址',
		'companyPhone': '公司电话',
		'pleaseInputCompanyPhone': '请输入公司电话',
		'openingBank': '开户银行',
		'pleaseInputOpeningBank': '请输入开户银行',
		'bankAccount': '银行账号',
		'pleaseInputBankAccount': '请输入银行账号',
		'remark': '备注',
		'pleaseInputRemark': '请输入备注',
		'email': '电子邮箱',
		'pleaseInputEmail': '请填写邮箱地址',
		'cancel': '取消',
		'submit': '提交',
		'invoiceResult': '开票结果',
		'invoiceSubmitted': '开票申请已提交',
		'invoiceExpectedTip': '发票预计将在48小时以内开出，请注意查收',
		'viewInvoiceStatus': '查看开票状态',
		'pleaseInputHeaderName': '请填写抬头名称',
		'pleaseInputValidEmail': '请输入正确的邮箱地址',
		'invoiceApplyFailed': '开票申请失败',
		'viewInvoice': '查看发票',
		'downloadPdf': '下载PDF文件',
		'manualService': '人工客服',
		'invoiceSentToEmail': '发票信息已发送到邮箱，请注意查收',
		'pleaseWaitInvoicing': '请耐心等待开票完成',
		'pleaseContactManual': '请联系人工进行开票',
		'noPdfAvailable': '暂无可下载的PDF文件',
		'serviceUnavailable': '客服功能暂不可用',

	}
}
export default cn;